import React from 'react';
import type { FC } from 'react';
import { styled } from '@material-ui/core';
import Tag, { TagProps } from '@/components/Tag';
import { theme } from '@/theme/mui-theme';

interface Props {
  readonly tags: TagProps[];
}

const Container = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  columnGap: theme.spacing(1),
  rowGap: theme.spacing(1)
});

const Tags : FC<Props> = (({ tags }) => {
  if (tags.length === 0) {
    return null;
  } else {
    return (
      <Container>
        { tags.map(({ type, label }) =>
          <Tag
            key={label}
            type={type}
            label={label}
          />
        ) }
      </Container>
    );
  }
});

export default Tags;
